import { useMutation } from '@apollo/client';
import React from 'react';

import { MANUAL_PRE_APPROVAL_GUARANTEE_UPDATE, MANUAL_REPAYMENT_UPDATE } from '../../../../../graphql/admin_mutations';
import ImageModalComp from '../../../../../components/ImageModalComp';
import useForm from '../../../../../customHooks/useForm';
import useToast from '../../../../../customHooks/useToast';

type Props = {
  closeModal:any;
  docName: string;
  loanScheduleId?: string;
  preApprovalGuaranteeId?: string;
  refetch: any;
  permissionName?: string;
}

const MarkAsPaidComp = ({
  closeModal, docName, loanScheduleId, refetch, preApprovalGuaranteeId, permissionName,
}: Props) => {
  const [manualPreApprovalGuaranteeUpdate] = useMutation<
  { manualPreApprovalGuaranteeUpdate: any },
   any
>(MANUAL_PRE_APPROVAL_GUARANTEE_UPDATE);

  const [manualRepaymentUpdate] = useMutation<
  { manualRepaymentUpdate: any },
  any
>(MANUAL_REPAYMENT_UPDATE);
  const [uploadLoading, setUploadLoading] = React.useState(false);
  const [uploadFile, setUploadFile] = React.useState<any>(null);
  const { formValues, handleChange } = useForm({
    documentType: docName,
    documentId: '',
  });
  const Toast = useToast();
  const handleSubmit = async () => {
    if (!uploadFile) {
      Toast.error('Please select a file to upload');
      return;
    }
    setUploadLoading(true);
    try {
      const mutation = preApprovalGuaranteeId
        ? manualPreApprovalGuaranteeUpdate : manualRepaymentUpdate;
      const id = preApprovalGuaranteeId || loanScheduleId;

      const variables = {
        file: uploadFile,
        id,
      };

      const res = await mutation({
        variables,
      });

      if (res?.data) {
        const { message, status } = handleResponse(res?.data, !!preApprovalGuaranteeId);

        if (status === 200) {
          Toast.success(message);
          refetch?.();
          closeModal(false);
          setUploadFile(null);
        } else {
          Toast.error(message);
        }
      }
    } catch (e) {
      if (e && e.graphQLErrors && e.graphQLErrors.length > 0) {
        Toast.error(e.graphQLErrors[0].message);
      } else {
        Toast.error('Something went wrong');
      }
    }
    setUploadLoading(false);
  };

  const handleResponse = (res, isManualPreApproval) => {
    if (!res) return;

    const key = isManualPreApproval ? 'manualPreApprovalGuaranteeUpdate' : 'manualRepaymentUpdate';
    const message = res?.[key]?.message;
    const status = res?.[key]?.status;

    return { message, status };
  };

  return (
    <ImageModalComp
      closeModal={closeModal}
      title="Proof of Payment"
      text="Upload proof of payment"
      uploadFile={uploadFile}
      setUploadFile={setUploadFile}
      viewOnly
      value={formValues?.documentType}
      handleChange={handleChange}
      uploadLoading={uploadLoading}
      onSubmit={handleSubmit}
      permissionName={permissionName || 'can-approve-loan'}
    />
  );
};

export default MarkAsPaidComp;
